// =====================================
//
//   補收款 信用卡付款 Controller
//   Author: Gray
//   createtime: 2017 / 03 / 16
//
// =====================================

window.InifECMobileApp.controller("ExtrafeePaymentSinopacCreditCardController", ['$scope', '$state', '$timeout', '$rootScope', '$stateParams', 'UserService', 'ExtraFeeService',
	function($scope, $state, $timeout, $rootScope, $stateParams, UserService, ExtraFeeService) {

        var getExtraFee = function() {

            $scope.isLoading = true;
            ExtraFeeService.getExtraFee($scope.extrafeeid).then(function(result) {

                $scope.isLoading = false;

                if(result) {
                    $scope.extrafee = result;
                    $scope.orderid = $scope.extrafee.orderid;
                    
                    if($scope.extrafee.status != 300) {
                        $state.go(window.STATES.ORDER, {orderid: $scope.orderid});
                        return;
                    }

                    pay();

                } else {
                    $scope.isError = true;
                }

            }, function(error) {
                if(error && error.code == 'error.itemIsNotExist') {
                    $scope.isExtrafeeNotExist = true;
                } else {
                    $scope.isError = true;
                }
                
                $scope.isLoading = false;
            });
        }
        
        var pay = function() {

            if(!$scope.extrafee || $scope.isPaying) {
                return;
            }

            var extrafeeid = $scope.extrafeeid,
                paymentmethod = Paytype_SinopacCreditCard,
                totalamount = $scope.extrafee.totalamount;

            $scope.isPaying = true;

            ExtraFeeService.payExtraFee(extrafeeid, paymentmethod, totalamount).then(function(result) {
                if(result) {
                        // 因為信用卡付款會直接導頁，所以不讓讀取狀態停止，不然會很奇怪
                } else {
                    $scope.isError = true;
                    $scope.isPaying = false;
                }             
            }, function(error) {
                $scope.isError = true;
                $scope.isPaying = false;
            });
        }

        var init = function() {
            
            UserService.getUserInfo().then(function(result) {
                $scope.isLogin = true;
                getExtraFee();
            }, function(error) {
                $scope.isLogin = false;

                $state.go(window.STATES.HOME);
            });
        }

	    //==========================
        //  Events
        //==========================
        $scope.$on("LOGOUT_SUCCESS", function(event, data) {
            init();
        });

        //==========================
        //  Members
        //==========================
        $scope.extrafeeid = $stateParams.extrafeeid;
        $scope.orderid = $stateParams.orderid;
        $scope.extrafee;

        $scope.isLoading = false;
        $scope.isError = false;
        $scope.isPaying = false;
        $scope.isExtrafeeNotExist = false;

        //==========================
        //  Methods
        //==========================

        //==========================
        //  Init
        //==========================
        init();
	}
]);